import React from 'react'

import {
  Icon,
  Add,
  Button,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import { usePreviewMode } from 'Pods/ItemPage/context/PreviewModeContext'

function AddButton({
  id = '',
  openSidebar: handleOpenSidebar,
  ariaLabel,
  onMouseEnter:
  handleMouseEnter,
  onTouchStart: handleTouchStart,
}) {
  const { isPreview } = usePreviewMode()

  return (
    <div className="area-add-button">
      <Button
        id={id}
        trailIcon={<Icon svgComponent={Add} />}
        type="ghost"
        variant="with-icon"
        onClick={handleOpenSidebar}
        onMouseEnter={handleMouseEnter}
        onTouchStart={handleTouchStart}
        size="small"
        aria-label={ariaLabel}
        disabled={isPreview}
      >
        Add
      </Button>
    </div>
  )
}

AddButton.propTypes = {
  id: string,
  openSidebar: func.isRequired,
  ariaLabel: string.isRequired,
  onMouseEnter: func,
  onTouchStart: func,
}

export default AddButton
